module.exports = __webpack_public_path__ + "9841f3d906521f7479a5ba70612aa8c8.ttf";